var map = {
	"./aboutUs.js": 85816,
	"./account.js": 57670,
	"./artificialIntelligence.js": 30178,
	"./geologicalMetallurgy.js": 43623,
	"./home.js": 17878,
	"./localization.js": 72556,
	"./memberTerms.js": 83708,
	"./menu.js": 60310,
	"./militaryIndustry.js": 31800,
	"./pharmaceutical.js": 74784,
	"./servicePrice.js": 99049,
	"./successCase.js": 78922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84833;